import React from 'react'
import { format } from 'date-fns'
import { buildVerificationAuditEvents } from '../studentDetailVerification'

const VerificationAuditLog = ({ data }) => {
    const events = buildVerificationAuditEvents(data)

    return (
        <div className='auditLogBlock'>
            <h3 className='auditLogHeading'>Verification Audit Log</h3>
            {events.length === 0 ? (
                <p style={{ marginTop: 0, color: '#666' }}>No verification events yet.</p>
            ) : (
                <div className='auditLogTableWrap'>
                    <table className='auditLogTable'>
                        <thead>
                            <tr>
                                <th>Date &amp; Time</th>
                                <th>User</th>
                                <th>Action</th>
                                <th>Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {events.map((event) => (
                                <tr key={event.id}>
                                    <td>{format(new Date(event.at), 'dd MMM yyyy hh:mm a')}</td>
                                    <td><strong>{event.actorName}</strong></td>
                                    <td>{event.type === 'record_update' ? 'Updated form' : `${event.action} ${event.label}`}</td>
                                    <td>
                                        {event.type === 'record_update' ? (
                                            <div className='auditChangeList'>
                                                {event.changes.map((change) => (
                                                    <span key={`${event.id}-${change.fieldKey}`} className='auditChangeItem'>
                                                        <strong>{change.label}</strong>: {change.fromValue || '-'} → {change.toValue || '-'}
                                                    </span>
                                                ))}
                                            </div>
                                        ) : (event.value || '—')}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    )
}

export default VerificationAuditLog
